import React, { useEffect, useMemo } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks';
import Paths from 'routes';
import { getAccessToken } from 'utils/token-utils';
import { Loading } from 'components/molecules';

interface Props {}

const Authority = ({ children }: React.PropsWithChildren<Props>): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const { isLoading } = useAuth();

  /* ======================================================
   * variables
   * ====================================================== */
  const isErrorPage = useMatch(Paths.pathObject.error);

  const isValid = useMemo(() => !!getAccessToken(), [location.pathname, isLoading]);


  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (isLoading || isErrorPage) return;

    const isPublic = Paths.getProperty(location.pathname, 'public');    
    if (!isValid && !isPublic) {
      navigate(Paths.pathObject.login);
    } else if (isValid && window.location.pathname === Paths.pathObject.login) {
      navigate('/');
    }
  }, [isLoading, isValid, isErrorPage]);

  /* ======================================================
   * render items
   * ====================================================== */
  if (isLoading) return <Loading />;

  return <>{children}</>;
};

export default Authority;
